// extracted by mini-css-extract-plugin
module.exports = {"root":"notification_root__14eGt"};